(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[408],{

/***/ 8886:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/[slug]",
      function () {
        return __webpack_require__(1066);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Recommendations; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _SingleArticle_SingleArticle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1081);



function Recommendations(param) {
    let { data , title , link  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "recommendation_container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "recommendation_articles",
                children: data === null || data === void 0 ? void 0 : data.map((p, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SingleArticle_SingleArticle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        link: link,
                        data: p
                    }, i))
            })
        ]
    });
}


/***/ }),

/***/ 9451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DiscoverBeneBono; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8945);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7561);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1126);






function DiscoverBeneBono() {
    const [userEmail, setUserEmail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [isEmpty, setIsEmpty] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isSend, setIsSend] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [lang, setLang] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const topLevelDomain = window.location.hostname.split(".").pop();
        setLang(topLevelDomain === "es" ? "es" : "fr");
    }, []);
    const susbcriptionNewsLetter = ()=>axios__WEBPACK_IMPORTED_MODULE_5__/* ["default"].post */ .Z.post("https://eo2uod9d6ddkieu.m.pipedream.net", {
            userEmail,
            lang
        }).then((res)=>{
            if (res) {
                setIsSend(true);
            }
        }).catch((error)=>{
            console.log(error);
        });
    function handleChange(e) {
        setUserEmail(e.target.value);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "discover_container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: t("discover.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                        children: t("discover.first.subtitle")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("discover.first.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                        children: t("discover.second.subtitle")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("discover.second.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                        children: t("discover.third.subtitle")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("discover.third.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/checkout",
                className: "button",
                children: t("button.baskets")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: t("newsletter.title")
            }),
            !isSend ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("newsletter.description")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        onChange: handleChange,
                        type: "email",
                        placeholder: "manuel@exemple.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "button",
                        onClick: ()=>{
                            if (userEmail) {
                                susbcriptionNewsLetter();
                            }
                            if (!userEmail) {
                                setIsEmpty(true);
                            }
                        },
                        children: t("newsletter.button")
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "success_newsletter",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .HandCheck */ .zG, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("newsletter.already.subscribe")
                    })
                ]
            }),
            isEmpty && !isSend ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                style: {
                    color: "red",
                    margin: 0,
                    marginTop: "5px",
                    paddingLeft: "10px"
                },
                children: t("email.error.format")
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: t("socials.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: t("socials.description")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "socials_container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.instagram.com/benebono.es/" : "https://www.instagram.com/benebono.fr/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Instagram */ .mr, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.facebook.com/benebono.es/" : "https://www.facebook.com/benebono.fr/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Facebook */ .s1, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.linkedin.com/company/benebono-fr" : "https://www.linkedin.com/company/benebono-fr",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Linkedin */ .n6, {})
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 61:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7561);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1126);





function Footer(param) {
    let { links , locale  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const lang = locale || "fr";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                children: [
                    t("footer.title.1"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    " ",
                    t("footer.title.2"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    " ",
                    t("footer.title.3"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .FooterHeadingHand */ .dy, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "footer_links_page",
                children: links.map((l, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: l.href,
                        children: l.label
                    }, i))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: "footer_company_info",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            "Bene Bono\xae ",
                            new Date().getFullYear()
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: lang !== "es" && "https://static.horsnormes.co/static/legal/20220224-BeneBono-Politique-De-Confidentialite.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.privacynotice")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: lang !== "es" ? "https://static.horsnormes.co/static/legal/20241001-CGV-BeneBono.pdf" : "https://static.horsnormes.co/static/legal/CGV-spain.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.conditionsofuse")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://static.horsnormes.co/static/legal/20241001-BeneBono-MentionsLegales.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.legal_mentions")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: t("footer.cookies")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .LogoFooter */ .vP, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer_socials",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.instagram.com/benebono.es/" : "https://www.instagram.com/benebono.fr/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Instagram */ .mr, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.facebook.com/benebono.es/" : "https://www.facebook.com/benebono.fr/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Facebook */ .s1, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.linkedin.com/company/benebono-fr" : "https://www.linkedin.com/company/benebono-fr",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Linkedin */ .n6, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer_benebono_info",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.email")
                            }),
                            lang === "es" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.openhour")
                            }),
                            lang === "es" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.phonenumber")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.address")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.certification")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.certification.code")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function ShareButton(param) {
    let { icon , text , href  } = param;
    return /*#__PURE__*/ _jsxs("a", {
        href: href,
        className: "share_button",
        children: [
            icon,
            text
        ]
    });
}


/***/ }),

/***/ 1081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SingleArticle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_3__);




dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("fr");
function SingleArticle(param) {
    let { data , link  } = param;
    var _data_attributes_preview_image_data_, _data_attributes, _data_attributes_preview_image, _data_attributes_preview_image_data__attributes, _data_attributes_tags_data_, _data_attributes_tags, _data_attributes1, _data_attributes2, _data_attributes3, _data_attributes4, _data_attributes5;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "recommendation_article",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                data.attributes.preview_image.data != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (_data_attributes_preview_image_data_ = (_data_attributes = data.attributes) === null || _data_attributes === void 0 ? void 0 : (_data_attributes_preview_image = _data_attributes.preview_image) === null || _data_attributes_preview_image === void 0 ? void 0 : _data_attributes_preview_image.data[0]) === null || _data_attributes_preview_image_data_ === void 0 ? void 0 : (_data_attributes_preview_image_data__attributes = _data_attributes_preview_image_data_.attributes) === null || _data_attributes_preview_image_data__attributes === void 0 ? void 0 : _data_attributes_preview_image_data__attributes.url
                }) : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: (_data_attributes_tags_data_ = (_data_attributes_tags = data.attributes.tags) === null || _data_attributes_tags === void 0 ? void 0 : _data_attributes_tags.data[0]) === null || _data_attributes_tags_data_ === void 0 ? void 0 : _data_attributes_tags_data_.attributes.name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/".concat(link, "/").concat(data === null || data === void 0 ? void 0 : (_data_attributes1 = data.attributes) === null || _data_attributes1 === void 0 ? void 0 : _data_attributes1.slug),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        children: data === null || data === void 0 ? void 0 : (_data_attributes2 = data.attributes) === null || _data_attributes2 === void 0 ? void 0 : _data_attributes2.title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "article_info",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: data === null || data === void 0 ? void 0 : (_data_attributes3 = data.attributes) === null || _data_attributes3 === void 0 ? void 0 : _data_attributes3.author
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: dayjs__WEBPACK_IMPORTED_MODULE_3___default()((_data_attributes4 = data.attributes) === null || _data_attributes4 === void 0 ? void 0 : _data_attributes4.publishedAt).format("DD MMMM YYYY")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: data === null || data === void 0 ? void 0 : (_data_attributes5 = data.attributes) === null || _data_attributes5 === void 0 ? void 0 : _data_attributes5.description
                })
            ]
        })
    }, data === null || data === void 0 ? void 0 : data.id);
}


/***/ }),

/***/ 1066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ RecipePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 47 modules
var esm = __webpack_require__(7561);
// EXTERNAL MODULE: ./assets/index.js + 26 modules
var assets = __webpack_require__(1126);
// EXTERNAL MODULE: ./components/ArticleRecommendation/ArticleRecommendation.js
var ArticleRecommendation = __webpack_require__(5996);
// EXTERNAL MODULE: ./components/DiscoverBeneBono/DiscoverBeneBono.js
var DiscoverBeneBono = __webpack_require__(9451);
// EXTERNAL MODULE: ./components/Footer/Footer.js
var Footer = __webpack_require__(61);
// EXTERNAL MODULE: ./components/Nav/Nav.js
var Nav = __webpack_require__(4193);
// EXTERNAL MODULE: ./components/ShareButton/ShareButton.js
var ShareButton = __webpack_require__(576);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 19 modules
var lib = __webpack_require__(1209);
;// CONCATENATED MODULE: ./graphql/posts.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ($pageSize: Int, $locale: I18NLocaleCode!) {\n    blogPosts(pagination: { pageSize: $pageSize }, locale: $locale) {\n      data {\n        attributes {\n          slug\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\nquery (\n  $page: Int!\n  $pageSize: Int!\n  $tags: [String]\n  $locale: I18NLocaleCode!\n) {\n  blogPosts(\n    pagination: { page: $page, pageSize: $pageSize }\n    filters: { tags: { name: { in: $tags } } }\n    locale: $locale\n    sort: "publishedAt:desc"\n  ) {\n    data {\n      id\n      attributes {\n        title\n        description\n        slug\n        author\n        tags {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        createdAt\n        publishedAt\n        preview_image {\n          data {\n            attributes {\n              url\n              name\n            }\n          }\n        }\n      }\n    }\n    meta {\n      pagination {\n        page\n        pageSize\n        total\n        pageCount\n      }\n    }\n  }\n}\n'
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ($slugUrl: String!, $locale: I18NLocaleCode!) {\n    blogPosts(filters: { slug: { eq: $slugUrl } }, locale: $locale) {\n      data {\n        id\n        attributes {\n          title\n          description\n          slug\n          author\n          content\n          seo {\n            metaTitle\n            metaImage {\n              data {\n                attributes {\n                  url\n                }\n              }\n            }\n            metaDescription\n          }\n          tags {\n            data {\n              id\n              attributes {\n                name\n              }\n            }\n          }\n          createdAt\n          publishedAt\n          preview_image {\n            data {\n              attributes {\n                url\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ($locale: I18NLocaleCode!) {\n    tags(locale: $locale) {\n      data {\n        id\n        attributes {\n          name\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\nquery (\n  $tags: [String]\n  $locale: I18NLocaleCode!\n) {\n  blogPosts(\n    pagination: { limit: 3 }\n    filters: { tags: { name: { in: $tags } } }\n    locale: $locale\n    sort: "publishedAt:desc"\n  ) {\n    data {\n      id\n      attributes {\n        title\n        description\n        slug\n        author\n        tags {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        createdAt\n        publishedAt\n        preview_image {\n          data {\n            attributes {\n              url\n              name\n            }\n          }\n        }\n      }\n    }\n    meta {\n      pagination {\n        page\n        pageSize\n        total\n        pageCount\n      }\n    }\n  }\n}\n'
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}

const GET_ALL_SLUGS = (0,lib/* gql */.Ps)(_templateObject());
const GET_ALL_POSTS = (0,lib/* gql */.Ps)(_templateObject1());
const GET_INDIVIDUAL_POST = (0,lib/* gql */.Ps)(_templateObject2());
const GET_ALL_TAGS = (0,lib/* gql */.Ps)(_templateObject3());
const GET_LAST_ARTICLES_BY_TAGS = (0,lib/* gql */.Ps)(_templateObject4());


// EXTERNAL MODULE: ./utils/helpers/index.js
var helpers = __webpack_require__(905);
;// CONCATENATED MODULE: ./pages/recipes/[slug].js













var __N_SSG = true;
function RecipePage(param) {
    let { recipe , latestPosts , footer , navigation  } = param;
    var _recipe_seo, _recipe_seo1, _recipe_seo2, _recipe_seo_metaImage, _recipe_seo_metaImage_data, _recipe_seo_metaImage_data_attributes, _recipe_season_tags, _recipe_recipe_difficulty_data_, _recipe_recipe_difficulty, _recipe_recipe_difficulty_data__attributes, _recipe_preview_image_data_, _recipe_preview_image, _recipe_preview_image_data__attributes, _recipe_ingredient, _recipe_step;
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    (0,react.useEffect)(()=>{
        var _window_rudderanalytics;
        window === null || window === void 0 ? void 0 : (_window_rudderanalytics = window.rudderanalytics) === null || _window_rudderanalytics === void 0 ? void 0 : _window_rudderanalytics.page();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: recipe === null || recipe === void 0 ? void 0 : recipe.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: recipe === null || recipe === void 0 ? void 0 : (_recipe_seo = recipe.seo) === null || _recipe_seo === void 0 ? void 0 : _recipe_seo.metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Bene Bono"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: recipe === null || recipe === void 0 ? void 0 : (_recipe_seo1 = recipe.seo) === null || _recipe_seo1 === void 0 ? void 0 : _recipe_seo1.metaDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: recipe === null || recipe === void 0 ? void 0 : (_recipe_seo2 = recipe.seo) === null || _recipe_seo2 === void 0 ? void 0 : (_recipe_seo_metaImage = _recipe_seo2.metaImage) === null || _recipe_seo_metaImage === void 0 ? void 0 : (_recipe_seo_metaImage_data = _recipe_seo_metaImage.data) === null || _recipe_seo_metaImage_data === void 0 ? void 0 : (_recipe_seo_metaImage_data_attributes = _recipe_seo_metaImage_data.attributes) === null || _recipe_seo_metaImage_data_attributes === void 0 ? void 0 : _recipe_seo_metaImage_data_attributes.url
                    }),
                     false && /*#__PURE__*/ 0
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                links: navigation.links
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "single_recipe",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "article_header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "navigation_button",
                                onClick: ()=>router.push("/recipes"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* ArrowLeft */.Xd, {}),
                                    " ",
                                    t("back.to.recipes")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "tags",
                                children: recipe === null || recipe === void 0 ? void 0 : (_recipe_season_tags = recipe.season_tags) === null || _recipe_season_tags === void 0 ? void 0 : _recipe_season_tags.data.map((t, i)=>{
                                    var _t_attributes;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                        children: t === null || t === void 0 ? void 0 : (_t_attributes = t.attributes) === null || _t_attributes === void 0 ? void 0 : _t_attributes.name
                                    }, i);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: recipe === null || recipe === void 0 ? void 0 : recipe.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "recipe_info",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: (_recipe_recipe_difficulty_data_ = recipe === null || recipe === void 0 ? void 0 : (_recipe_recipe_difficulty = recipe.recipe_difficulty) === null || _recipe_recipe_difficulty === void 0 ? void 0 : _recipe_recipe_difficulty.data[0]) === null || _recipe_recipe_difficulty_data_ === void 0 ? void 0 : (_recipe_recipe_difficulty_data__attributes = _recipe_recipe_difficulty_data_.attributes) === null || _recipe_recipe_difficulty_data__attributes === void 0 ? void 0 : _recipe_recipe_difficulty_data__attributes.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: (recipe === null || recipe === void 0 ? void 0 : recipe.duration) <= 60 ? "".concat(recipe === null || recipe === void 0 ? void 0 : recipe.duration, " min") : (0,helpers/* timeConvert */.V5)(recipe === null || recipe === void 0 ? void 0 : recipe.duration)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ingredients_container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "ingredients_content",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (_recipe_preview_image_data_ = recipe === null || recipe === void 0 ? void 0 : (_recipe_preview_image = recipe.preview_image) === null || _recipe_preview_image === void 0 ? void 0 : _recipe_preview_image.data[0]) === null || _recipe_preview_image_data_ === void 0 ? void 0 : (_recipe_preview_image_data__attributes = _recipe_preview_image_data_.attributes) === null || _recipe_preview_image_data__attributes === void 0 ? void 0 : _recipe_preview_image_data__attributes.url
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        children: [
                                            t("ingredients.title"),
                                            (recipe === null || recipe === void 0 ? void 0 : recipe.ingredientBaseUnit) && (recipe === null || recipe === void 0 ? void 0 : recipe.ingredientBaseUnitName) ? " ".concat(t("ingredients.title.for"), " ").concat(recipe === null || recipe === void 0 ? void 0 : recipe.ingredientBaseUnit, " ").concat(recipe === null || recipe === void 0 ? void 0 : recipe.ingredientBaseUnitName) : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "ingredients",
                                        children: recipe === null || recipe === void 0 ? void 0 : (_recipe_ingredient = recipe.ingredient) === null || _recipe_ingredient === void 0 ? void 0 : _recipe_ingredient.map((i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* Checkmark */.MC, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: (i === null || i === void 0 ? void 0 : i.ingredient.charAt(0).toUpperCase()) + (i === null || i === void 0 ? void 0 : i.ingredient.slice(1))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            i === null || i === void 0 ? void 0 : i.quantity,
                                                            " ",
                                                            i === null || i === void 0 ? void 0 : i.unit
                                                        ]
                                                    })
                                                ]
                                            }, i);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: t("preparation.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "steps",
                                        children: recipe === null || recipe === void 0 ? void 0 : (_recipe_step = recipe.step) === null || _recipe_step === void 0 ? void 0 : _recipe_step.map((s, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "steps_header",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* HandLogo */.tR, {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                                children: [
                                                                    t("recipes.step"),
                                                                    " ",
                                                                    i + 1
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: s === null || s === void 0 ? void 0 : s.step
                                                    })
                                                ]
                                            }, i);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverBeneBono/* default */.Z, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleRecommendation/* default */.Z, {
                link: "recipes",
                title: t("last.recipes.title"),
                data: latestPosts
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                links: footer.links
            })
        ]
    });
}


/***/ }),

/***/ 905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "V5": function() { return /* binding */ timeConvert; },
/* harmony export */   "r_": function() { return /* binding */ printPrice; }
/* harmony export */ });
const printPrice = function() {
    let amountX100 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, currentSymbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "€", precision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    const formatPrice = "".concat((amountX100 / 100).toFixed(precision));
    const [euros, cents] = formatPrice.split(".");
    if (cents === "00") return "".concat(euros).concat(currentSymbol);
    return "".concat(formatPrice).concat(currentSymbol);
};
const debounce = (func, wait)=>{
    let timeout;
    return function executedFunction() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const later = ()=>{
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};
const timeConvert = (n)=>{
    var hours = n / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + "h" + rminutes + "m";
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,789,588,193,774,888,179], function() { return __webpack_exec__(8886); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);